import type { IDefect, IMediaFile } from '@condo/domain';
import { useMutation, useQuery } from '@tanstack/vue-query';

import { getDefect, saveDefect } from '@/api/basecamp.api';
import { withLoading } from '@/shared';

export const useDefect = defectId => {
    const query = useQuery(['defect', defectId], async (): Promise<IDefect> => withLoading(async () => getDefect(defectId)), {});

    const { mutate: updateDefectMutation } = useMutation(
        async ({ defect, media, note }: { defect: Partial<IDefect>; media?: IMediaFile[]; note?: string }) => saveDefect(defect, media, note),
        {
            onSuccess: () => query.refetch(),
        },
    );

    return { ...query, refetchDefect: query.refetch, updateDefect: updateDefectMutation };
};
